import {
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Switch,
  Text,
} from '@chakra-ui/react';
import { FC, useContext } from 'react';
import { BsPatchCheck, BsPatchExclamation } from 'react-icons/bs';
import Input from '../../../../components/Form/Input';
import { CoupomFormContext } from '../../context/CreateCoupomFormContext';

const ActiveCoupomText: FC<{ isActive: boolean }> = ({ isActive }) => {
  const text = isActive ? 'ativo' : 'inativo';
  const icon = isActive ? BsPatchCheck : BsPatchExclamation;
  const color = isActive ? 'cyan.500' : 'red.500';
  return (
    <Text as="em" fontSize="xs" fontStyle="italic" opacity="0.8">
      cupom {text} na VTEX
      <Icon as={icon} color={color} ml="2" />
    </Text>
  );
};

const CoupomForm: FC = () => {
  const [formData, setFormData] = useContext(CoupomFormContext);

  return (
    <Flex direction="column" justifyContent="start" gridGap="5">
      <Flex justifyContent="start" gridGap="5">
        <Flex direction="column" w="full">
          <Heading size="sm" as="h3">
            {formData.vtexCoupom.name}
          </Heading>
          <ActiveCoupomText isActive={formData.vtexCoupom.isActive} />
          <Text fontSize="xs">
            <Text as="strong" fontWeight="bold">
              Cód.:
            </Text>{' '}
            {formData.vtexCoupom.utmSource}
          </Text>
          <Text fontSize="xs">
            <Text as="strong" fontWeight="bold">
              Validade:
            </Text>{' '}
            {formData.vtexCoupom.beginDate.toLocaleDateString()} até{' '}
            {formData.vtexCoupom.endDate.toLocaleDateString()}
          </Text>
        </Flex>
        <Flex gridGap="2" w="full" direction="column">
          <Flex gridGap="2" w="full">
            <FormControl id="active" isRequired>
              <FormLabel htmlFor="active_switch" mb="0" fontSize="sm">
                Ativar Cupom
              </FormLabel>
              <Switch
                size="sm"
                id="active_switch"
                isChecked={formData.activeCoupom}
                onChange={e =>
                  setFormData(state => ({
                    ...state,
                    activeCoupom: e.target.checked,
                  }))
                }
              />
            </FormControl>
            <FormControl id="countdown" isRequired>
              <FormLabel htmlFor="countdown_switch" mb="0" fontSize="sm">
                Countdown
              </FormLabel>
              <Switch
                size="sm"
                id="countdown_switch"
                isChecked={formData.countdown}
                onChange={e =>
                  setFormData(state => ({
                    ...state,
                    countdown: e.target.checked,
                  }))
                }
              />
            </FormControl>
          </Flex>
          <FormControl id="vtex_query">
            <FormLabel mb="0" fontSize="sm">
              Query Vtex
            </FormLabel>
            <Input
              name="vtex_query"
              size="sm"
              placeholder="digite a query da VTEX"
              value={formData.queryVtex}
              onChange={e =>
                setFormData({ ...formData, queryVtex: e.target.value })
              }
            />
          </FormControl>
        </Flex>
      </Flex>
      <Flex direction="column" gridGap="5">
        <FormControl id="description">
          <FormLabel mb="0" fontSize="sm">
            Descrição
          </FormLabel>
          {formData.vtexCoupom.description ? (
            <Text fontSize="sm">{formData.vtexCoupom.description}</Text>
          ) : (
            <Text fontSize="sm" fontStyle="italic">
              cupom sem descrição
            </Text>
          )}
        </FormControl>
        <FormControl id="rules">
          <FormLabel mb="0" fontSize="sm">
            Regras
          </FormLabel>
          {formData.vtexCoupom.rules ? (
            <Text fontSize="sm" fontStyle="italic">
              {formData.vtexCoupom.rules}
            </Text>
          ) : (
            <Text fontSize="sm" fontStyle="italic">
              cupom sem regras
            </Text>
          )}
        </FormControl>
      </Flex>
    </Flex>
  );
};

export default CoupomForm;
